import React, { useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import WantedColumn from './WantedColumn';
import ExceptionColumn from './ExceptionColumn';

export default function WantedExceptionColumns() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const intl = useIntl();
  const { formatMessage } = intl;

  const categoryList = [
    { value: 1, label: formatMessage({ id: 'wanted.category.1' }), component: WantedColumn },
    { value: 2, label: formatMessage({ id: 'wanted.category.2' }), component: ExceptionColumn },
  ];

  const selectedItem = categoryList.find(item => item.value === selectedCategory);
  const Component = selectedItem && selectedItem.component ? selectedItem.component : null;
  return (
    <>
      <div className="settings-category frame">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'wanted.base' })}</div>
          <div className="settings-buttons" />
        </div>
        <div className="settings-list-wrapper">
          <div className="settings-list custom-scroll-theme">
            {categoryList.map((item, key) => (
              <div
                key={key}
                onClick={() => {
                  setSelectedCategory(item.value);
                }}
                className={classNames('settings-menu-item', { selected: selectedCategory === item.value })}
              >{item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      {Component ? <Component /> : <div className="settings-options frame" />}
    </>
  );
}
